<template>
    <div class="quick-reply-message-viewer">
        <div
            :style="{
                ...messageColors,
            }"
            class="sc-message--text"
        >
            <div>
                <span
                    class="sc-message--text-content"
                    style="margin-bottom: 0 !important"
                    v-html="data.raw.payload.message"
                ></span>

                <text
                    v-if="data.data.meta"
                    class="sc-message--meta"
                    style="color: darkcyan; font-weight: 600; font-size: smaller"
                >
                    {{ data.data.meta }}
                </text>
            </div>
        </div>
        <div class="quick-replies" v-if="!clickedButton">
            <div
                class="quick-reply"
                :class="{ disabled }"
                v-for="(button, i) in data.raw.payload.buttons"
                :key="button.id"
                @click="
                    sendButtonMessage('QUICK_REPLY', {
                        buttonId: button.id,
                        blockId: data.raw.payload.blockId,
                        payloadId: data.raw.payload.id,
                        uniqMessageId: data.raw.uniqMessageId,
                        buttonPayload: button.payload,
                    })
                "
            >
                <div class="quick-reply-text" v-html="button.title" />
            </div>
        </div>
    </div>
</template>

<script>
import _ from "lodash";
import { mapState } from "vuex";
import { sendSocketMessage } from "../../../../../utils/socketStream";
import { log2 } from "../../../../../utils/log2";

const log = log2("BotQuickReplyMessage");

export default {
    name: "BotQuickReplyMessage",
    props: {
        data: {
            type: Object,
            required: true,
        },
        messageColors: {
            type: Object,
            required: true,
        },
        messageStyling: {
            type: Boolean,
            required: true,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    computed: {
        ...mapState({
            siteId: (state) => _.get(state.site.site, "_id"),
        }),
    },
    data() {
        return {
            clickedButton: false,
        };
    },
    methods: {
        sendButtonMessage(type, payload) {
            if (this.disabled) return;
            log("sendButtonMessage", { type, payload, siteId: this.siteId });
            this.clickedButton = true;
            sendSocketMessage("chatbot/v2 user-button-select", {
                siteId: this.siteId,
                conversationId:
                    this.data.raw.conversationId ||
                    _.get(this.data.raw.conversation, "_id", this.data.raw.conversation),
                type,
                payload,
            });
        },
    },
    mounted() {
        log("mounted", this.data);
    },
};
</script>

<style lang="scss">
.quick-reply-message-viewer {
    .sc-message--text {
        width: 100% !important;
        max-width: 100% !important;
    }

    .msg {
        width: 100%;
        height: 100%;
        border-radius: 12px;
        padding: 6px 12px;
        background-color: #ffffff;
        position: relative;
    }

    .quick-replies {
        display: flex;
        flex-wrap: wrap;
        //margin: 6px -5px 0;
        width: 100%;

        .quick-reply {
            background: var(--chat-bubble-text);
            color: var(--chat-bubble-background);
            border: 1px solid var(--chat-bubble-background);

            border-radius: 16px;
            cursor: pointer;
            font-size: 16px;
            font-weight: 600;
            min-height: 32px;
            height: auto;
            line-height: 30px;
            margin: 10px 5px 0;
            min-width: 100px;
            padding: 0 16px;
            position: relative;
            text-align: center;
            transition: all 0.3s;
            &.disabled {
                opacity: 0.5 !important;
                cursor: not-allowed;
            }

            &:hover {
                opacity: 0.8 !important;
                transform: scale(1.05);
                webkit-box-shadow: 0 0px 0px rgba(0,0,0,.2) !important;
                .button-controls {
                    opacity: 1;
                }
            }
            .quick-reply-text {
                text-align: left;
                width: 100%;
                background: var(--chatbot-button-color) !important;
                border: 1px solid var(--chatbot-button-text-color) !important;
                color: var(--chatbot-button-text-color) !important;
                opacity: 0.8;
                border-radius: 6px !important;
                font-size: 12px;
                padding: 5px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/V2/popup-chat/messages/chatbot/BotQuickReplyMessage.vue